export default {
  apiTrafficManager: process.env.VUE_APP_BACKEND_URL || 'https://nakdan-u1-0.loadbalancer.dicta.org.il',
  withinNakdan: true
}
